import { X_Language, isMobile, cache, CountryCode } from '@/utils';
import dayjs from 'dayjs';
import Tracker from './tracker';

class PaymentTracker extends Tracker {
  /** confirmPage页面的事件埋点 */
  confirmPageTracker = ({ action, label = '' }) => {
    try {
      const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
      let eventLabel = label || `${cache.getCookie('insta_access_token') ? 'user' : 'guest'}_${time}_${X_Language}`;
      switch (action) {
        case 'payment_choose':
        case 'card_page':
        case 'card_confirm':
        case 'isLoggedIn':
        case 'review_placeOrder':
          eventLabel = `${label}`;
          break;
        default:
          break;
      }

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_confirmPayment`,
        action,
        label: eventLabel,
        value: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /** saleTax消费税埋点 */
  orderSaleTaxTracker = ({ action }) => {
    try {
      const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
      let eventLabel = `${CountryCode}_${
        cache.getCookie('insta_access_token') ? 'user' : 'guest'
      }_${time}_${X_Language}`;

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_order_salesTax`,
        action,
        label: eventLabel,
        value: 1,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * paylater事件埋点
   *
   */
  payLaterTracker = ({ action, label = '' }) => {
    let value = 1;
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_payment`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.error(e);
    }
  };

  /**
   * klarna事件埋点
   *
   */
  klarnaTracker = ({ action }) => {
    let value = 1;
    try {
      const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
      const language = X_Language;
      const path = document.location.pathname;

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_payment`,
        action,
        label: `${path}_${time}_${language}`,
        value,
      });
    } catch (e) {
      console.error(e);
    }
  };

  applePayTracker = ({ action, label = '' }) => {
    try {
      const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
      const language = X_Language;
      const path = document.location.pathname;

      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_payment_apple_pay`,
        action,
        label,
        value: `${path}_${time}_${language}`,
      });
    } catch (e) {
      console.error(e);
    }
  };

  /**
   * 云存储payment事件
   */
  cloudTracker = ({ action, label }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cloud_payment`,
        action,
        label,
      });
    } catch (e) {
      console.error(e);
    }
  };
}

const T = new PaymentTracker();
export default T;
